//
// ===== File globals.ts    
//
'use strict';

// export const API_URL: string = 'http://localhost:3000/api';  
export const API_URL: string = 'https://portal.bullseyesalesevents.com:1337/api';  

export const GOOGLE_MAP_API_KEY:string = 'AIzaSyBrQvvE6MAjNOE7A41GQR-TGKNMCP2PyZQ';
// export const GOOGLE_MAP_API_KEY:string = 'AIzaSyA0k8PLMNHXzeyYRm-AYGQemNlZXi8MPCo';



// WEBPACK FOOTER //
// /var/www/portal/bullseye/src/app/globals.ts